"use client";

import { AuthForm } from "@/components/change-password-form";
import { SubmitButton } from "@/components/submit-button";
import Link from "next/link";
import { useState, useEffect } from "react";
import { useRouter } from "next/navigation";
import { useSelector } from "react-redux";
import { toast } from "sonner";
import axios from "axios";

// export default function CompleteYourProfile() {
export default function ChangePasswordComp({
  show,
  handleClose,
}) {
  const [isSuccessful, setIsSuccessful] = useState(false);
  const [loading, setLoading] = useState(true);
  const router = useRouter();
  const { userData, fetchUserData } = useSelector((state) => state.main)

  const isProfileComplete = userData?.is_profile_complete === 1;

  return (
    <div className="inset-0 z-[100] flex items-start pt-12 md:pt-0 md:items-center justify-center bg-black bg-opacity-40 top-0 h-screen overflow-y-auto fixed md:h-auto md:overflow-visible px-4 md:px-0 pb-12 md:pb-0">
      {/* relative w-full max-w-lg overflow-hidden rounded-2xl flex flex-col gap-12 border border-[#d5d5d5] p-[30px] w-[calc(100%-50px)] bg-white dark:bg-[#1a1a1a] */}
      <div className="profile-popup relative flex flex-col gap-8 border border-[#d5d5d5] p-[20px] md:p-[30px] w-[calc(100%-50px)] w-full max-w-lg rounded-2xl border dark:border-white/10 border-black/10 dark:bg-neutral-900 bg-accent shadow-2xl ring-1 ring-black/5">
        {/* Modal Content */}
        <div className="flex flex-col items-start justify-center gap-2 text-start sm:px-0 px-0 mb-4">
          <h3 className="text-xl font-semibold dark:text-zinc-50">
            Change Password
            <div>
              <button
                onClick={() => {
                  if (false) {
                    toast.error("Complete your profile first before closing!", {
                      style: { color: "red" },
                      position: "top-center",
                      iconTheme: { primary: "red", secondary: "#fff" },
                    });
                    return;
                  }
                  handleClose();
                }}

                className="absolute rounded-md p-2 hover:bg-white/5 focus:outline-none focus-visible:ring-2 focus-visible:ring-white/30 leading-normal top-[15px] right-[10px] md:top-[25px] md:right-[30px]"
              >
                <svg
                  width="20"
                  height="20"
                  fill="currentColor"
                  className="text-gray-500 hover:text-black dark:text-gray-400 dark:hover:text-white"
                >
                  <path d="M14.25 4.75a.75.75 0 011.06 1.06L11.06 10l4.25 4.25a.75.75 0 11-1.06 1.06L10 11.06l-4.25 4.25a.75.75 0 11-1.06-1.06L8.94 10 4.69 5.75a.75.75 0 011.06-1.06L10 8.94l4.25-4.19z" />
                </svg>
              </button>
            </div>
          </h3>
          <p className="text-sm text-gray-500 dark:text-zinc-400">
            Fill Out The Following Fields To Change Your Password
          </p>
        </div>
        <div className="flex flex-col gap-2">
          <AuthForm setIsSuccessful={setIsSuccessful} handleClose={handleClose}>
            <div className="grid grid-cols-2 gap-2">
              <SubmitButton isSuccessful={isSuccessful}>Update</SubmitButton>
              <button
                type="button"
                onClick={async () => {
                  localStorage.clear();
                  await axios.post(
                    // "https://site.varnz.ai/api/users/logout",
                     `${process.env.NEXT_PUBLIC_APP_SITE_WEBSITE_URL}api/users/logout`,
                    {},
                    { withCredentials: true }  // ✅ Cookie clear hone ke liye zaroori
                  );
                  window.location.href = "/login";
                }}
                className="relative bg-[#000000] text-[#fafafa] dark:bg-[#ffffff] dark:text-[#000000] rounded-md px-4 py-2 text-sm font-medium"
              >
                Logout
              </button>
            </div>
          </AuthForm>
        </div>
      </div>
    </div>
  );
}
